<template>
  <ul>
    <li v-for="experience in experienceContent" :key="experience.id">
      <div class="icon">
        <i class="fa fa-briefcase"></i>
      </div>
      <span class="time open-sans-font text-uppercase">{{
        experience.year
      }}</span>
      <h5 class="poppins-font text-uppercase">
        {{ experience.position }}
        <span class="place open-sans-font">{{ experience.compnayName }}</span>
      </h5>
      <p class="open-sans-font">{{ experience.details }}</p>
    </li>
  </ul>
</template>

<script>
export default {
  data() {
    return {
      experienceContent: [
        {
          id: 1,
          year: "2021 - Obecnie",
          position: "Software Engineer",
          compnayName: "Soltix Software House",
          details: `W Soltix razem z innymi członkami zespołu dostarczamy oprogramowanie wspomagające oraz optymalizujące
          procesy dla średnich i dużych firm`,
        },
        {
          id: 2,
          year: "2016 - 2021",
          position: "Full Stack",
          compnayName: "CREHLER Sp. z o.o.",
          details: `Wdrażanie oraz implementacja nowych rozwiązań na platformę Shopware 5 oraz 6`,
        },
        {
          id: 3,
          year: "   2014 - 2016",
          position: "Programista PHP & front-end",
          compnayName: "Crehel Janusz Michalewicz",
          details: `Implementacja, support oraz rozbudowa sklepów internetowych opartych na systemie Shopware 5`,
        },
        {
          id: 4,
          year: "   2012- 2014",
          position: " Web Developer",
          compnayName: "Dogo System",
          details: `  Programista stron oraz aplikacji webowych`,
        },
        {
          id: 5,
          year: "2010 - 2011",
          position: " Web Developer",
          compnayName: "PHU ELKA Systemy informatyczne",
          details: `Praca z framwerokiem CakePHP przy tworzeniu małych i średnich systemów CMS/CRM`,
        },
        {
          id: 6,
          year: "2005 - 2013",
          position: "Stażysta",
          compnayName: "Narodowy Fundusz Zdrowia NFZ",
          details: `Database Administrator Trainee`,
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped></style>
